import { presaleContractAddress, usdtTokenAddress } from "data/consts";
import { BigNumber, ethers } from "ethers";
import usdtAbi from "data/usdtAbi.json";
import presaleABI from "data/preSaleAbi.json";

const MaxUint256: BigNumber = /*#__PURE__*/ BigNumber.from(
  "0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"
);

export const checkApproveState = async (signer, from) => {
  try {
    const usdtContract = new ethers.Contract(usdtTokenAddress, usdtAbi, signer);
    const response = await usdtContract.allowance(from, presaleContractAddress);
    const value = ethers.utils.formatEther(response);
    if (value > 0) return true;

    return false;
  } catch (e) {
    console.log(e);
    return false;
  }
};

export const getApproveForUsdt = async (signer) => {
  try {
    const usdtContract = new ethers.Contract(usdtTokenAddress, usdtAbi, signer);
    await usdtContract.approve(presaleContractAddress, MaxUint256, {
      gasLimit: 1e5,
    });
  } catch (e) {
    console.log(e);
  }
};
export const handleBuyWithUsdt = async (signer, amount) => {
  await getApproveForUsdt(signer);
  const preSaleContract = new ethers.Contract(
    presaleContractAddress,
    presaleABI,
    signer
  );

  return preSaleContract.buyWithUSDT(amount, {});
};
export const handleBuyEth = async (signer, pmcAmount, ethAmount) => {
  const ethFormatted = ethAmount * Math.pow(10, 18);
  const preSaleContract = new ethers.Contract(
    presaleContractAddress,
    presaleABI,
    signer
  );
  const deploymentData = await preSaleContract.estimateGas.buyWithEth(
    pmcAmount,
    {
      value: ethFormatted.toString(),
      gasLimit: 2e5,
    }
  );

  return preSaleContract.buyWithEth(pmcAmount, {
    value: ethFormatted.toString(),
    gasLimit: deploymentData,
  });
};
